import { Component, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { BaseHomeComponent } from '../base.home.component';
import { SiteService } from '../../../core/site';
import { SelectedSiteService } from '../../../selected-site.service';
import { SiteEditService } from '../../../core/site-edit';
import { LocalStorageService } from '@vendasta/uikit';
import { AppConfigService } from '../../../core/app-config.service';
import { Observable } from 'rxjs';
import { UserService } from '../../../core/user.service';
import { map } from 'rxjs/operators';
import { AnalyticsService } from '../../analytics/analytics.service';
import { PhpVersionService } from '../../../core/php-version';
import { PhpVersionChangeComponent } from '../php-version-change/php-version-change.component';
import { MatDialog } from '@angular/material/dialog';
import { ProductAnalyticsService } from '@vendasta/product-analytics';

@Component({
  selector: 'app-site-home',
  templateUrl: './site.home.component.html',
  styleUrls: ['./site.home.styles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SiteHomeComponent extends BaseHomeComponent implements OnDestroy {
  isPartnerStaffOnSite$: Observable<boolean>;
  ga4ViewNotFound$: Observable<boolean>;
  gaViewNotFound$: Observable<boolean>;
  phpVersion: string;
  phpVersion$: Observable<any>;
  wpCoreVersion: string = null;
  loadingPhpVersion = false;
  connectGALink$: Observable<string>;
  connectGALinkLoading$: Observable<boolean>;
  connectGALinkError$: Observable<boolean>;
  public showCloudArmorBanner = false;
  public showPhp81Banner = false;
  public showSupportUpgradeBanner = false;

  constructor(
    protected siteService: SiteService,
    protected selectedSiteService: SelectedSiteService,
    protected siteEditService: SiteEditService,
    protected localStorageService: LocalStorageService,
    protected appConfigService: AppConfigService,
    protected userService: UserService,
    private gaAnalyticsService: AnalyticsService,
    public readonly analyticsService: ProductAnalyticsService,
    private phpVersionService: PhpVersionService,
    public modal: MatDialog,
  ) {
    super(
      siteService,
      selectedSiteService,
      siteEditService,
      localStorageService,
      appConfigService,
      userService,
      analyticsService,
    );
    const partnerId$ = this.siteService.get().pipe(map((site) => site.partnerId));
    this.isPartnerStaffOnSite$ = this.userService.partnerStaffOnSite$(partnerId$);
    this.ga4ViewNotFound$ = this.gaAnalyticsService.ga4ViewNotFound$;
    this.gaViewNotFound$ = this.gaAnalyticsService.gaViewNotFound$;
    this.connectGALink$ = this.gaAnalyticsService.connectGALink$;
    this.connectGALinkLoading$ = this.gaAnalyticsService.connectGALinkLoading$;
    this.connectGALinkError$ = this.gaAnalyticsService.connectGALinkError$;

    this.phpVersion$ = this.phpVersionService
      .getPhpVersionState$()
      .pipe(map((phpVersionState) => phpVersionState.sitePhpVersion));
    this.phpVersion$.subscribe((e) => (this.phpVersion = e));
    this.showCloudArmorBanner = this.localStorageService.get('cloudArmorDismissed') !== '1' ? true : false;
    this.showPhp81Banner = this.localStorageService.get('php81BannerDismissed') !== '1' ? true : false;
    this.showSupportUpgradeBanner = this.localStorageService.get('supportUpgradeDismissed') !== '1';
  }

  updatePHP(): void {
    this.loadingPhpVersion = true;
    this.siteUpdate$.subscribe((data) => {
      this.wpCoreVersion = data.core_version;
      this.loadingPhpVersion = false;
      this.modal.open(PhpVersionChangeComponent, {
        width: '500px',
        data: {
          php_version: this.phpVersion,
          wp_version: this.wpCoreVersion,
        },
      });
    });
  }

  connectGA4(): void {
    this.connectGALinkLoading$.subscribe((connectGALinkLoading) => {
      if (!connectGALinkLoading) {
        this.connectGALinkError$.subscribe((connectGALinkError) => {
          if (!connectGALinkError) {
            this.connectGALink$.subscribe((url) => {
              window.open(url, '_blank');
            });
          }
        });
      }
    });
  }

  closeCloudArmor(): void {
    this.localStorageService.set('cloudArmorDismissed', '1');
    this.showCloudArmorBanner = false;
  }

  closePhp81Banner(): void {
    this.localStorageService.set('php81BannerDismissed', '1');
    this.showPhp81Banner = false;
  }

  closeSupportUpgradeBanner(): void {
    this.localStorageService.set('supportUpgradeDismissed', '1');
    this.showSupportUpgradeBanner = false;
  }
}
